import * as yup from "yup";

const schema = yup.object().shape({
    tipoCabo: yup.object().shape({
        value: yup.number().required(),
        label: yup.string()
    }),
    codigoOcupante: yup.object().required("Este campo é obrigatório").shape({
        value: yup.string().required("Este campo é obrigatório"),
        label: yup.string()
    }),
    Cidades: yup.object().required("Este campo é obrigatório").shape({
        value: yup.number().required("Este campo é obrigatório"),
        label: yup.string()
    }),
    Bairros: yup.object().required("Este campo é obrigatório").shape({
        value: yup.number().required("Este campo é obrigatório"),
        label: yup.string()
    })
});

const defaultValues = {
    codigoCidade: 0,
    codigoBairro: 0,
    codigoRegiao: 0,
    tipoCabo: {
        value: undefined,
        label: "Selecione o tipo de cabo"
    },
    Protocolo: "",
    emailRepresentante: "",
    nomeRepresentante: "",
    cpfRepresentante: "",
    dataInicioInstalacao: new Date(1900, 0, 1, 1, 1, 1, 1),
    dataTerminoInstalacao: new Date(1900, 0, 1, 1, 1, 1, 1),
    situacao: 0,
    qtdePontos: 0,
}

export { defaultValues, schema }